import * as React from "react";
import { SVGProps } from "react";

const Thorecoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 213 130"
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={282.25}
        x2={412.86}
        y1={1336.26}
        y2={1336.26}
        gradientTransform="translate(-312.97 -1271.14)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#3b007f" />
        <stop offset={1} stopColor="#aa003d" />
      </linearGradient>
    </defs>
    <circle cx={65.12} cy={65.12} r={65.12} fill="url(#a)" />
    <circle cx={57.58} cy={82.27} r={4.88} />
    <circle cx={71.99} cy={82.27} r={4.88} />
    <circle cx={86.4} cy={82.27} r={4.88} />
    <circle cx={100.82} cy={82.27} r={4.88} />
    <circle cx={115.24} cy={82.27} r={4.88} />
    <circle cx={129.65} cy={82.27} r={4.88} />
    <circle cx={144.07} cy={82.27} r={4.88} />
    <circle cx={158.48} cy={82.27} r={4.88} />
    <circle cx={172.89} cy={82.27} r={4.88} />
    <circle cx={180.92} cy={96.88} r={3.36} />
    <circle cx={166.02} cy={96.88} r={3.36} />
    <circle cx={151.13} cy={96.88} r={3.36} />
    <circle cx={136.24} cy={96.88} r={3.36} />
    <circle cx={121.34} cy={96.88} r={3.36} />
    <circle cx={106.44} cy={96.88} r={3.36} />
    <circle cx={91.55} cy={96.88} r={3.36} />
    <circle cx={76.65} cy={96.88} r={3.36} />
    <circle cx={61.76} cy={96.88} r={3.36} />
    <circle cx={188.83} cy={107.15} r={3.26} />
    <circle cx={173.72} cy={107.15} r={3.26} />
    <circle cx={158.61} cy={107.15} r={3.26} />
    <circle cx={143.51} cy={107.15} r={3.26} />
    <circle cx={128.4} cy={107.15} r={3.26} />
    <circle cx={113.29} cy={107.15} r={3.26} />
    <circle cx={98.19} cy={107.15} r={3.26} />
    <circle cx={83.08} cy={107.15} r={3.26} />
    <circle cx={67.97} cy={107.15} r={3.26} />
    <circle cx={199.36} cy={117.51} r={2.49} />
    <circle cx={184.05} cy={117.51} r={2.49} />
    <circle cx={168.74} cy={117.51} r={2.49} />
    <circle cx={153.44} cy={117.51} r={2.49} />
    <circle cx={138.13} cy={117.51} r={2.49} />
    <circle cx={122.82} cy={117.51} r={2.49} />
    <circle cx={107.51} cy={117.51} r={2.49} />
    <circle cx={92.21} cy={117.51} r={2.49} />
    <circle cx={76.9} cy={117.51} r={2.49} />
    <circle cx={211.62} cy={126.74} r={1.91} />
    <circle cx={196.19} cy={126.74} r={1.91} />
    <circle cx={180.75} cy={126.74} r={1.91} />
    <circle cx={165.32} cy={126.74} r={1.91} />
    <circle cx={149.89} cy={126.74} r={1.91} />
    <circle cx={134.45} cy={126.74} r={1.91} />
    <circle cx={119.02} cy={126.74} r={1.91} />
    <circle cx={103.59} cy={126.74} r={1.91} />
    <circle cx={88.15} cy={126.74} r={1.91} />
    <circle cx={50.56} cy={68.48} r={3.36} />
    <circle cx={65.45} cy={68.48} r={3.36} />
    <circle cx={80.35} cy={68.48} r={3.36} />
    <circle cx={95.24} cy={68.48} r={3.36} />
    <circle cx={110.14} cy={68.48} r={3.36} />
    <circle cx={125.04} cy={68.48} r={3.36} />
    <circle cx={139.93} cy={68.48} r={3.36} />
    <circle cx={154.83} cy={68.48} r={3.36} />
    <circle cx={169.72} cy={68.48} r={3.36} />
    <circle cx={42.65} cy={58.21} r={3.26} />
    <circle cx={57.76} cy={58.21} r={3.26} />
    <circle cx={72.87} cy={58.21} r={3.26} />
    <circle cx={87.97} cy={58.21} r={3.26} />
    <circle cx={103.08} cy={58.21} r={3.26} />
    <circle cx={118.18} cy={58.21} r={3.26} />
    <circle cx={133.29} cy={58.21} r={3.26} />
    <circle cx={148.4} cy={58.21} r={3.26} />
    <circle cx={163.5} cy={58.21} r={3.26} />
    <circle cx={32.12} cy={47.85} r={2.49} />
    <circle cx={47.43} cy={47.85} r={2.49} />
    <circle cx={62.74} cy={47.85} r={2.49} />
    <circle cx={78.04} cy={47.85} r={2.49} />
    <circle cx={93.35} cy={47.85} r={2.49} />
    <circle cx={108.66} cy={47.85} r={2.49} />
    <circle cx={123.97} cy={47.85} r={2.49} />
    <circle cx={139.27} cy={47.85} r={2.49} />
    <circle cx={154.58} cy={47.85} r={2.49} />
    <circle cx={19.86} cy={38.62} r={1.91} />
    <circle cx={35.29} cy={38.62} r={1.91} />
    <circle cx={50.72} cy={38.62} r={1.91} />
    <circle cx={66.16} cy={38.62} r={1.91} />
    <circle cx={81.59} cy={38.62} r={1.91} />
    <circle cx={97.03} cy={38.62} r={1.91} />
    <circle cx={112.46} cy={38.62} r={1.91} />
    <circle cx={127.89} cy={38.62} r={1.91} />
    <circle cx={143.33} cy={38.62} r={1.91} />
  </svg>
);

export default Thorecoin;
